
      var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShowPasswordIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.92 15.615c-.041-.092-1.03-2.284-3.226-4.48C23.767 8.206 20.069 6.66 16 6.66c-4.07 0-7.767 1.547-10.694 4.474-2.197 2.197-3.19 4.393-3.226 4.481a.934.934 0 0 0 0 .759c.041.092 1.03 2.283 3.226 4.48C8.233 23.78 11.931 25.327 16 25.327c4.07 0 7.767-1.547 10.694-4.473 2.197-2.197 3.185-4.388 3.226-4.48a.933.933 0 0 0 0-.759ZM16 23.46c-3.591 0-6.728-1.306-9.325-3.88a15.57 15.57 0 0 1-2.692-3.587 15.556 15.556 0 0 1 2.692-3.587c2.597-2.574 5.734-3.88 9.325-3.88 3.591 0 6.728 1.306 9.325 3.88a15.572 15.572 0 0 1 2.698 3.587C27.18 17.563 23.517 23.46 16 23.46Z",
  fill: "var(--theme-primary, #810ea9)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 4.5,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\r\n  <path d=\"M29.9195 15.6153C29.8787 15.5232 28.8905 13.331 26.6937 11.1341C23.7665 8.20698 20.0693 6.65998 16 6.65998C11.9307 6.65998 8.23349 8.20698 5.30632 11.1341C3.10949 13.331 2.11666 15.5267 2.08049 15.6153C2.02742 15.7347 2 15.8639 2 15.9945C2 16.1251 2.02742 16.2543 2.08049 16.3737C2.12132 16.4658 3.10949 18.6568 5.30632 20.8537C8.23349 23.7797 11.9307 25.3267 16 25.3267C20.0693 25.3267 23.7665 23.7797 26.6937 20.8537C28.8905 18.6568 29.8787 16.4658 29.9195 16.3737C29.9726 16.2543 30 16.1251 30 15.9945C30 15.8639 29.9726 15.7347 29.9195 15.6153ZM16 23.46C12.409 23.46 9.27183 22.1545 6.67483 19.5808C5.60924 18.5211 4.70268 17.3128 3.98332 15.9933C4.70248 14.6737 5.60907 13.4654 6.67483 12.4058C9.27183 9.83215 12.409 8.52665 16 8.52665C19.591 8.52665 22.7282 9.83215 25.3252 12.4058C26.3928 13.4651 27.3014 14.6735 28.0225 15.9933C27.1813 17.5637 23.5168 23.46 16 23.46Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <circle cx=\"16\" cy=\"16\" r=\"4.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/show-password-icon.426bc0e84ef28337e8576646667445ef.svg"),
        {
          React: SvgShowPasswordIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      